import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class TeacherCard extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        const {teacher} = this.props;
        return (
            <div className="single-teacher">
                <Link to={`/teacher/${teacher.id}`}>
                    <div className="img-wrapper">
                        <img src={teacher.image} className="img-fluid" alt="تصویر استاد" />
                    </div>
                    <div className="details">
                        <h4 className="name">{teacher.fullName}</h4>
                        <span class="border"><div class="border__inner"></div></span>
                        <p className="education">{teacher.summary}</p>
                        <p className="uni">{teacher.education}</p>
                    </div>
                </Link>
            </div>
        );
    }
}